import React, { FC, ReactElement } from 'react';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import UserApplicationPage from 'buyside/components/presentation/UserApplication/userApplicationPage';
import ReCAPTCHAMutationContainer, {
  ReCAPTCHAMutationChildrenProps
} from 'buyside/components/container/MutationContainers/ReCAPTCHA/ReCAPTCHAMutationContainer';

import { initialValues } from 'buyside/components/presentation/UserApplication/Helpers/userApplicationPageConstants';

import { ApplicantTypes } from 'interfaces/userApplication/userApplication';

import {
  useCreateOrUpdateUserApplicationMutation,
  useUserApplicationQuery
} from 'interfaces/graphql-typings';

const UserApplicationPageContainer: FC<{
  appId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}> = ({ appId, email, firstName, lastName }): ReactElement => {
  const { data, loading: existingApplicationLoading } = useUserApplicationQuery({
    variables: { id: appId },
    skip: !appId
  });

  const [createOrUpdateUserApplication, { loading }] = useCreateOrUpdateUserApplicationMutation();

  const applicantType = data?.userApplication?.applicantType
    ? data?.userApplication?.applicantType === 'pro'
      ? ApplicantTypes.pro
      : ApplicantTypes.basic
    : null;

  return (
    <ReCAPTCHAMutationContainer pageName="the user application" action="UserApplication">
      {({ grecaptcha }: ReCAPTCHAMutationChildrenProps): ReactElement => (
        <>
          {existingApplicationLoading ? (
            <LoadingSpinner />
          ) : (
            <UserApplicationPage
              applicantType={applicantType}
              createOrUpdateUserApplication={createOrUpdateUserApplication}
              grecaptcha={grecaptcha}
              initialPage={data?.userApplication ? 2 : 0}
              initialValues={
                data?.userApplication || { ...initialValues, email, firstName, lastName }
              }
              isLoading={loading}
            />
          )}
        </>
      )}
    </ReCAPTCHAMutationContainer>
  );
};

export default UserApplicationPageContainer;
